export const tasksQueryKey = (status?: string) => {
  return status ? ['tasks', status] : ['tasks'];
};

export const taskQueryKey = (id: string) => ['task', id];

export const taskFileQueryKey = (id: string) => ['task', 'files', id];

export const practiceFileQueryKey = (id: string) => ['practice', 'files', id];

export const appealReviewsQueryKey = () => ['appealReviews'];

export const appealReviewQueryKey = (id: string) => ['appealReview', id];

export const priorAuthReviewsQueryKey = () => ['priorAuthReviews'];

export const priorAuthReviewQueryKey = (id: string) => ['priorAuthReview', id];

export const expiringPriorAuthsQueryKey = () => ['expiringPriorAuths'];

export const notificationsQueryKey = () => ['portalNotifications'];

export const inboundTaskOptionsQueryKey = (prescriptionId?: string) => ['inboundTaskOptions', prescriptionId || 'all'];
